import http from "../http-common";

export default class UploadService {

  uploadSingleBatch(file, token, maand) {
    let formData = new FormData();
    file.forEach(element => {
        formData.append("file[]", element);
    });
    return http.post("/api/fotos/" + maand, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": "Bearer " + token
      }
    });
  }

  deleteFiles(maand, token) {
    return http.delete("/api/fotos/" + maand, {
      headers: {
        "Authorization": "Bearer " + token
      }
    });
  }
}
